import { User } from "../../Models/User";
import { ActionTypes } from "../ProjectActionTypes";

export const authActionTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  NOT_AUTHORISED: "NOT_AUTHORISED",
} as const;

export type UserAuthAction = {
  type: any;
  payload?: UserAuthPayload;
};

export type UserAuthPayload = {
  user?: User;
};

export const loggedIn = (user: User) => {
  sessionStorage.setItem("authorized", "true");
  const authAction: UserAuthAction = {
    type: authActionTypes.LOGIN,
    payload: { user: user },
  };
  return authAction;
};

export const loggedOut = () => {
  sessionStorage.removeItem("authorized");
  const authAction: UserAuthAction = {
    type: authActionTypes.LOGOUT,
  };
  return authAction;
};

export const notAuthorised = () => {
  sessionStorage.removeItem("authorized");
  return { type: authActionTypes.NOT_AUTHORISED };
};
